function currentlyOnVerifyPhoneNumberPage () {
  return /^\/#\/verify-phone(?:\?.*)?$/.test(getCurrentLocation())
}

export function redirectToVerifyPhoneNumber () {
  if (currentlyOnVerifyPhoneNumberPage()) {
    return
  }

  window.location.href = '/#/verify-phone?redirect=' + encodeURIComponent(getCurrentLocation())
}

function getCurrentLocation () {
  return window.location.pathname + window.location.hash
}
